import { style } from '@vanilla-extract/css';
import { vars } from '../../theme/contract.css';

export const body = style({
  lineHeight: vars.typography.lineHeight.normal,
  fontSize: vars.typography.fontSize.sm,
});
